import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { CitiesWithStates } from "app/_models/cities-with-states";
import { CommonservicesService } from "app/_services/commonservices.service";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { UserModel } from "app/_models/user-model";
import { AddCityComponent } from "./add-city.component";
import { EditCityComponent } from "./edit-city.component";
declare const swal: any;
@Component({
  selector: "app-city-master",
  templateUrl: "./city-master.component.html",
  styleUrls: ["./city-master.component.css"],
})
export class CityMasterComponent implements OnInit, AfterViewInit {
  currentUser: UserModel;
  isAdminGroupUser: boolean = false;
  cities: CitiesWithStates[];
  displayedColumns: string[] = ["icon", "stateName", "cityName", "edit", "delete"];
  dataSource = new MatTableDataSource<CitiesWithStates>([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = false;
  resultLength = 0;
  editCity:CitiesWithStates;

  constructor(
    private readonly matDialog: MatDialog,
    public datepipe: DatePipe,
    private readonly commonService: CommonservicesService,
    private readonly _liveAnnouncer: LiveAnnouncer
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.getcities();
  }

  getcities() {
    this.commonService.getAllCitiesWithState().subscribe((data) => {
      this.cities = data;
      this.dataSource = new MatTableDataSource<CitiesWithStates>(this.cities);
       this.dataSource.paginator = this.paginator;  
      this.dataSource.sort = this.sort;             
      this.resultLength = this.cities.length;
      this.isLoaderResult = false;
    });
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  exportExcel() {
    //stateName", "cityName"
    const workSheet = XLSX.utils.json_to_sheet(
      this.dataSource.data.map((item) => {
        return { State: item.stateName, City: item.cityName };
      })
    );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
    let fileName =
      "City_" +
      this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
      ".xlsx";
    XLSX.writeFile(workBook, fileName);
  }

  softDelete(e: any, element: any) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteCity(e, element);
      }
    });
  }

  deleteCity(e: any, element: any): void {
    this.isLoaderResult = true;
    let model = { id: element.cityId, updatedBy:"" };
    this.commonService.deleteCity(model).subscribe((data) => {
      if (data.didError) {
        swal({
          title: "",
          text: data.message + "\n" + data.additionalMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      } else {
        swal({
          title: "",
          text: data.message,
          type: "success",
          confirmButtonClass: "btn btn-info",
        });
        this.isLoaderResult = false;
        this.ngOnInit();
      }
    });
    
  }
  
  updateCity(e:any, element:any): void {
   this.editCity = JSON.parse(JSON.stringify(element)) ;//deep copy
   const dialogRef =  this.matDialog.open(EditCityComponent, {
      width: '800px',
      disableClose: true,
      data: this.editCity
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getcities();
        setTimeout(() => {}, 1500);
      }
    });
     
  }


  openDialog() {
    const dialogRef = this.matDialog.open(AddCityComponent, {
      width: "50%",
      disableClose: false,
      data: {
        pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
      },
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
          this.getcities();
        setTimeout(() => {}, 1500);
      }
    });
  }

   applyFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }
}
